(() => {
  class CBAnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.toggle = this.querySelector('.cb-announcement-marquee__toggle');
      this.setAttribute('data-ready', '');
      this.toggle.hidden = false;
      this.toggle.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? 'Pornește derularea anunțurilor' : 'Oprește derularea anunțurilor');
        this.querySelector('[data-marquee-pause]').hidden = paused;
        this.querySelector('[data-marquee-play]').hidden = !paused;
      }, { signal: this.events.signal });
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
  }
  if (!customElements.get('cb-announcement-marquee')) customElements.define('cb-announcement-marquee', CBAnnouncementMarquee);
})();
